/**
 * Send the reader to the contact page.
 *
 * Three components used to do this by querySelector-ing a path into the header
 * that ended `ul > li:nth-child(10) > a` (or 11) and calling .click() on it.
 * That encodes the contact link's ORDINAL POSITION in the navigation into
 * unrelated files: reorder the nav and the button quietly goes somewhere else,
 * remove an item and querySelector returns null so the click throws
 * "Cannot read properties of null (reading 'click')". Grouping the header into
 * Learn and Company dropdowns changed that index, which is how three separate
 * buttons would have broken at once.
 *
 * A destination belongs in one place. This is it.
 */
export const CONTACT_PATH = '/contact';

export default function goToContact() {
  window.location.assign(CONTACT_PATH);
}
